var _defs, _path, _path2, _g, _path3, _rect, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3450 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {fill: #FF0000;}\n            .cls-2 {fill: #1240AB;}\n            .cls-7 {fill: #ffffff;}\n            .cls-8 {stroke: #ffffff;}\n            .cls-9 {stroke-width: 12.50px;}\n            .cls-10 {stroke-width: 25px;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.48,25l-300.33.88A39.43,39.43,0,0,0,165,45.71L15.7,306.24a39.45,39.45,0,0,0,0,39.43L166.67,605.35A39.44,39.44,0,0,0,200.88,625l300.35-.86a39.48,39.48,0,0,0,34.09-19.83l149.43-260.6a39.53,39.53,0,0,0-.12-39.46L533.71,44.63A39.52,39.52,0,0,0,499.48,25Z",
    transform: "translate(-10.44 -25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 cls-8 cls-10",
    d: "M494.06,55.81,199.32,59.74a3.93,3.93,0,0,0-3.4,2L51.9,327a3.89,3.89,0,0,0,0,3.93l151,261.34a3.92,3.92,0,0,0,3.46,2l294.83-3.93a3.93,3.93,0,0,0,3.4-2L648.63,323a3.92,3.92,0,0,0,0-3.84l-151-261.33A3.92,3.92,0,0,0,494.06,55.81Z",
    transform: "translate(-10.44 -25)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2 cls-8 cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.49,162.44c11.32,20.6,13.75,28.79.37,36.79-17.11,10.19-24,3-35.37-17.57s-13.32-28.55,4.07-38.2C347.52,134.74,351.21,141.87,362.49,162.44Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.33,231.43c11.32,20.57,13.76,28.77.38,36.76-17.12,10.2-24,3-35.37-17.56S184,222,201.41,212.43C217.34,203.71,221,210.84,232.33,231.43Z",
    transform: "translate(-10.44 -25)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.21,159.46c-13.58-24.68-42.62-34.76-64.84-22.52l-11.79,6.5c.75,1.22,1.49,2.44,2.22,3.7,16.94,29.77,28.71,49.4-3.83,66.21-28.75,14.86-40.81-1.1-57.77-30.86-.92-1.63-1.81-3.29-2.63-4.94l-68,37.34c.81,1.27,1.6,2.55,2.34,3.93,17,29.75,23.05,50.81-5.89,64.84-30.95,15.07-38.69.16-55.63-29.61-1-1.69-2-3.42-2.75-5.13l-17,9.35c-22.24,12.24-29.29,42.17-15.71,66.81L241,499.86c13.58,24.67,42.62,34.75,64.84,22.51L526.6,401.08c22.26-12.24,29.29-42.17,15.71-66.81Z",
    transform: "translate(-10.44 -25)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 211.31,
    y: 257.05,
    width: 292.1,
    height: 195.59,
    transform: "translate(-137.21 191.13) rotate(-28.81)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.43,
    y: 327.9,
    width: 54.41,
    height: 41.97,
    transform: "translate(-148.91 133.67) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.9,
    y: 295.72,
    width: 54.41,
    height: 41.97,
    transform: "translate(-126.16 157.86) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.21,
    y: 265.35,
    width: 54.41,
    height: 41.97,
    transform: "translate(-103.92 181.15) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.96,
    y: 231.33,
    width: 54.41,
    height: 41.97,
    transform: "translate(-80.65 206.3) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.07,
    y: 379.96,
    width: 54.41,
    height: 41.97,
    transform: "translate(-170.45 153.91) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.55,
    y: 347.82,
    width: 54.41,
    height: 41.97,
    transform: "translate(-147.72 178.11) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.15,
    y: 315.59,
    width: 54.41,
    height: 41.97,
    transform: "translate(-124.94 202.37) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.61,
    y: 283.43,
    width: 54.41,
    height: 41.97,
    transform: "translate(-102.2 226.56) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.02,
    y: 434.66,
    width: 54.41,
    height: 41.97,
    transform: "translate(-192.35 173) rotate(-28.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 400.24,
    width: 54.41,
    height: 41.97,
    transform: "translate(-169.42 198.51) rotate(-28.81)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.65,427.09l-.31-160.33L875.8,400.37H861.34L781.8,267.7V427.09H751.62V207H777.4L869.2,361.7,959.74,207h25.78l.31,220.06Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.89,260.47,1114.1,443.75C1099.32,479,1080.15,490,1054.68,490c-16,0-32.38-5.35-42.75-15.41l12.89-22.63a42.6,42.6,0,0,0,29.86,12.26c14.46,0,23.58-6.6,31.75-25.78l5.35-11.63-73.57-166.31h31.44l58.16,133.3,57.53-133.3Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.37,372.08H1335.42l-24.21,55h-32.38L1378.49,207h31.12l100,220.06h-33Zm-11-25.15-47.48-107.84-47.47,107.84Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.48,343.78c0,51.25-35.53,85.2-84.26,85.2-23.58,0-44.32-9.12-58.16-27v86.14h-30.18V260.47h28.93v26.41c13.51-18.55,34.89-28,59.41-28C1675,258.9,1710.48,292.85,1710.48,343.78Zm-30.5,0c0-35.21-24.21-58.47-56.27-58.47-31.76,0-56,23.26-56,58.47,0,35.53,24.2,58.79,56,58.79C1655.77,402.57,1680,379.31,1680,343.78Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.88,343.78c0,51.25-35.52,85.2-84.25,85.2-23.58,0-44.33-9.12-58.16-27v86.14h-30.18V260.47h28.92v26.41c13.52-18.55,34.9-28,59.42-28C1889.36,258.9,1924.88,292.85,1924.88,343.78Zm-30.49,0c0-35.21-24.21-58.47-56.28-58.47-31.75,0-56,23.26-56,58.47,0,35.53,24.21,58.79,56,58.79C1870.18,402.57,1894.39,379.31,1894.39,343.78Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1951.29,343.78c0-49.67,36.78-84.88,86.77-84.88s86.45,35.21,86.45,84.88-36.46,85.2-86.45,85.2S1951.29,393.45,1951.29,343.78Zm142.73,0c0-35.52-23.89-58.47-56-58.47s-56.27,22.95-56.27,58.47,24.2,58.79,56.27,58.79S2094,379.31,2094,343.78Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2161,208.91c0-11,8.8-19.8,20.44-19.8s20.43,8.49,20.43,19.18c0,11.31-8.49,20.12-20.43,20.12C2169.78,228.41,2161,219.92,2161,208.91Zm5.35,51.56h30.18V427.09h-30.18Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2412.17,331.21v95.88H2382V334.67c0-32.7-16.35-48.73-45-48.73-32.06,0-52.81,19.17-52.81,55.33v85.82H2254V260.47H2283v25.15c12.26-17,33.64-26.72,60.05-26.72C2383.56,258.9,2412.17,282.16,2412.17,331.21Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2561.82,417.35c-9.12,7.86-23,11.63-36.47,11.63-33.64,0-52.82-18.55-52.82-52.19V285.31h-28.29V260.47h28.29V224h30.18v36.47h47.79v24.84h-47.79v90.22c0,17.92,9.43,28,26.1,28a38,38,0,0,0,23.57-7.86Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2874.93,331.21v95.88h-30.18V334.67c0-32.7-15.72-48.73-43.07-48.73-30.18,0-50,19.17-50,55.33v85.82h-30.18V334.67c0-32.7-15.72-48.73-43.07-48.73-30.18,0-50,19.17-50,55.33v85.82h-30.18V260.47h28.92v24.84c12-17,32.39-26.41,57.53-26.41,25.47,0,46.85,10.06,57.85,30.81,12.58-18.86,35.84-30.81,64.13-30.81C2847.27,258.9,2874.93,282.16,2874.93,331.21Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3081.48,353.84H2946.3c3.77,29.24,27.35,48.73,60.36,48.73,19.49,0,35.84-6.6,48.1-20.12l16.66,19.49c-15.09,17.61-38,27-65.71,27-53.75,0-89.59-35.53-89.59-85.2,0-49.36,35.52-84.88,83.62-84.88s82.37,34.58,82.37,85.82C3082.11,347.24,3081.79,351,3081.48,353.84ZM2946.3,332.15h106.89c-3.15-28-24.21-47.79-53.45-47.79C2970.82,284.36,2949.44,303.86,2946.3,332.15Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3282.06,331.21v95.88h-30.18V334.67c0-32.7-16.35-48.73-45-48.73-32.07,0-52.82,19.17-52.82,55.33v85.82h-30.18V260.47h28.93v25.15c12.26-17,33.63-26.72,60-26.72C3253.45,258.9,3282.06,282.16,3282.06,331.21Z",
    transform: "translate(-10.44 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3431.7,417.35c-9.11,7.86-22.95,11.63-36.46,11.63-33.64,0-52.82-18.55-52.82-52.19V285.31h-28.29V260.47h28.29V224h30.18v36.47h47.79v24.84H3372.6v90.22c0,17.92,9.43,28,26.09,28a38,38,0,0,0,23.58-7.86Z",
    transform: "translate(-10.44 -25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c4b258871f407226bc64c0e7d05b78f3.svg";
export { ForwardRef as ReactComponent };